<template>
  <article>
    <h3>Needs Attention</h3>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-card v-if="atRiskSlos && atRiskSlos.length" height="100%">
          <v-card-title>
            <div class="subheading grey--text">SLOs At Risk</div>
          </v-card-title>
          <v-card-text>
            <div v-for="(slo, idx) of atRiskSlos" :key="idx">
              <SLOAtRisk :slo="slo" />
            </div>
          </v-card-text>
        </v-card>

        <v-card v-else height="100%">
          <v-card-title>
            <div class="subheading grey--text">SLOs At Risk</div>
          </v-card-title>
          <v-card-text>
            <div class="display-1 text-xs-center">
              <v-icon x-large color="success">done</v-icon>
              Healthy
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card v-if="incidents && incidents.length" height="100%">
          <v-card-title>
            <div class="subheading grey--text">Active Incidents</div>
          </v-card-title>
          <v-card-text>
            <div v-for="(incident, idx) of incidents" :key="idx">
              <AlertSummary 
                :incident="incident"
                :appName="incident.trigger.rateSlo.app.name"
                :sloName="incident.trigger.rateSlo.name"
              />
            </div>
          </v-card-text>
        </v-card>

        <v-card v-else height="100%">
          <v-card-title>
            <div class="subheading grey--text">Active Incidents</div>
          </v-card-title>
          <v-card-text>
            <div class="display-1 text-xs-center grey--text">
              No Active Incidents
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </article>
</template>

<script>
import AlertSummary from "@/components/AlertSummary";
import SLOAtRisk from "@/components/SLOAtRisk";

var moment = require("moment");

export default {
  name: "Summary",
  components: {
    AlertSummary,
    SLOAtRisk
  },
  props: {
    incidents: {
      type: Array,
      required: true
    },
    apps: {
      type: Array,
      required: true
    },
  },
  computed: {
    atRiskSlos() {
      if (!this.apps) {
        return [];
      }

      var atRisk = [];

      for (let app of this.apps) {
        atRisk = atRisk.
          concat(app.rateSlos.filter(slo => this.budgetPct(slo) < 30.0)).
          map(slo => {
            slo.appName = app.name;
            return slo;
          });
      }

      return atRisk;
    }
  },
  methods: {
    budgetPct(slo) {
      var pct = 100.0 * slo.currentErrorBudget.remainingBudget / slo.currentErrorBudget.totalBudget;
      return pct.toFixed(1);
    },
  }
};
</script>
